//
//
//
//
//
//

import EditDate from './EditDate.vue'
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    blankVisible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  components: {
    EditDate,
  },
  data() {
    return {}
  },
  methods: {},
}
